
$(document).ready( function(){
	if ($('.bookmark-button').length > 0){

		$('.bookmark-button').on('click', function(e){

			e.preventDefault();
			e.stopPropagation();

			var button = $(this);

			var data ={
				id: button.attr('data-id'),
				classname: button.attr('data-classname'),
				is_bookmarked: button.attr('data-isbookmarked')
			};

			button.addClass('button--working');

			$.ajax({
				url: button.attr('data-url'),
				method: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(data)
			}).done(function(response){
				
				button.attr('data-isbookmarked', response.is_bookmarked);

				if (response.is_bookmarked){
					button.addClass('bookmark-button--bookmarked');
				} else {
					button.removeClass('bookmark-button--bookmarked');
				}

			}).fail(function(error){
				console.error(error);
			}).always(function(){
    			button.removeClass('button--working');
			});
	    });
	}
});